export function getParams() {
  return {
    is_settings: true,
  }
}
